import { FixedIncomeOfferBaseEntity } from '@genial/services';
import type { FixedIncomePositionEntity } from '@genial/services';
import { FixedIncomeRequestsFixedIncomeOfferCategoriesResponse } from '@genial/services/dist/models';
import { atom } from 'recoil';

import { applicationRangeDefault, daysRangeDefault } from '../../../pages/NewApplication/Filter';
import { fixedIncomeOperationTypeInitialTab, pagination, sortItemsFixedIncome } from '../constants';
import {
  FixedIncomeOffersByFilterParams,
  FixedIncomeOffersBySearchTerm,
  type FixedIncomeRescueOffersBySearchTerm,
} from '../types';

export const fixedIncomeOffersAllState = atom({
  key: 'fixedIncomeOffersAllState',
  default: [] as FixedIncomeOfferBaseEntity[],
});

export const fixedIncomeOffersByFilterParamsState = atom({
  key: 'fixedIncomeOffersByFilterParamsState',
  default: {
    ...pagination,
    sortItems: sortItemsFixedIncome,
    applicationMaximumAmount: applicationRangeDefault.max,
    applicationMinimumAmount: applicationRangeDefault.min,
    minimumDaysToRedemption: daysRangeDefault.min,
    maximumDaysToRedemption: daysRangeDefault.max,
  } as FixedIncomeOffersByFilterParams,
});

export const fixedIncomeOffersBySearchTermState = atom({
  key: 'fixedIncomeOffersBySearchTermState',
  default: [] as FixedIncomeOfferBaseEntity[],
});

export const fixedIncomeOffersBySearchTermParamsState = atom({
  key: 'fixedIncomeOffersBySearchTermParamsState',
  default: {
    ...pagination,
    skipEndpointCall: true,
    sortItems: sortItemsFixedIncome,
  } as FixedIncomeOffersBySearchTerm,
});

export const fixedIncomeCategoriesFilterState = atom({
  key: 'fixedIncomeCategoriesFilterState',
  default: { data: [] as FixedIncomeRequestsFixedIncomeOfferCategoriesResponse[] },
});

export const fixedIncomeOffersOperationTypeState = atom({
  key: 'fixedIncomeOffersOperationTypeState',
  default: fixedIncomeOperationTypeInitialTab,
});

export const fixedIncomeRescueOffersAllState = atom({
  key: 'fixedIncomeRescueOffersAllState',
  default: [] as FixedIncomePositionEntity[],
});

export const fixedIncomeRescueOffersBySearchTermParamsState = atom({
  key: 'fixedIncomeRescueOffersBySearchTermParamsState',
  default: {
    skipEndpointCall: true,
  } as FixedIncomeRescueOffersBySearchTerm,
});

export const fixedIncomeRescueOffersBySearchTermState = atom({
  key: 'fixedIncomeRescueOffersBySearchTermState',
  default: [] as FixedIncomePositionEntity[],
});
